<template>
  <div class="container">
    <div class="head">
        <div class="title">
          <div class="text">游客投诉处置效率</div>
          <div class="branch">-0.3</div>
        </div>
        <div class="tip">
          <div class="con">大理州-大理市</div>
          <div class="con">一类地区</div>
        </div>
        <div class="date">2019-11-01 12:31:22</div>
      </div>
    <div class="pg-pd12">
      <div>
           <causeDeduction  :causeContent="causeContent"></causeDeduction>
      </div>
      <div class="main">
        <div class="title">扣分详情</div>
        <div class="content">
          <div class="deduc-item">
            <div class="name">投诉量</div>
            <div class="cont">234起</div>
          </div>
          <div class="deduc-item">
            <div class="name">
              <div>平均办结时长</div>
              <div class="txt">平均办结时长=有效已办结投诉件处理时长</div>
              <div class="txt">+有效已办结投诉件数</div>
            </div>
            <div class="cont">253分钟</div>
          </div>
          <div class="deduc-item">
            <div class="name">排名</div>
            <div class="cont">2</div>
          </div>
        </div>
      </div>
      <div class="complain">
        <span>查看投诉案件列表</span>
      </div>
      <complainForm :tableList="tableList"></complainForm>
   </div>
  </div>
</template>
<script>
    import causeDeduction from './components/causeDeduction';// 扣分原因
    import complainForm from './components/form';// 表格
    import api from '../../service/modules/appraise';

    export default {
        components: {
            causeDeduction, complainForm
        },

        data () {
            return {
                causeContent: '万人投诉率5.12%，排名位于一类城市第二名',
                tableList: [
                    {
                        ranking: '1',
                        areaName: '保山',
                        complainNum: '235',
                        complain_rate: '36小时',
                        deduction: '5.0'
                    },
                    {
                        ranking: '2',
                        areaName: '保山',
                        complainNum: '235',
                        complain_rate: '36小时',
                        deduction: '5.0'
                    },
                    {
                        ranking: '3',
                        areaName: '保山',
                        complainNum: '235',
                        complain_rate: '36小时',
                        deduction: '5.0'
                    },
                    {
                        ranking: '4',
                        areaName: '保山',
                        complainNum: '235',
                        complain_rate: '36小时',
                        deduction: '5.0'
                    },
                    {
                        ranking: '5',
                        areaName: '保山',
                        complainNum: '235',
                        complain_rate: '36小时',
                        deduction: '5.0'
                    },
                    {
                        ranking: '6',
                        areaName: '保山',
                        complainNum: '235',
                        complain_rate: '36小时',
                        deduction: '5.0'
                    }
                ]

            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.assessDetail = res.data.assessDetail
                        this.causeContent = res.data.assessDetail.deductionReason// 扣分原因
                        this.complainRateInfo = res.data.assessDetail.complainRateInfo// 投诉率详情
                        this.tableList = res.data.assessDetail.complainRateList // 州市投诉率列表
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoreList'
                })
            }
        },

        mounted () {
        },

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }
        .head{
          width: 100%;
          background: #fff;
          padding: 24px 12px;
          margin-bottom: 24px;
          .title{
            height:22px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text{
              font-size:20px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .branch{
              height:22px;
              font-size:22px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,77,77,1);
              line-height:22px;
            }
        }
        .tip{
          margin-top:12px;
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(54,179,116,1);
          .con{
            border:1Px solid rgba(54,179,116,1);
            padding: 2px 4px;
            margin-right:14px;
          }
        }
        .date{
          margin-top:12px;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:12px;
        }
    }
.main{
      margin-top: 24px;
      .title{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        padding: 16px;
        .deduc-item{
          display: flex;
          justify-content: space-between;font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          padding-bottom: 12px;
          .name{
            color: #999999;
            .txt{
              font-size:12px;
              margin-top: 4px;
            }
          }
          .cont{
            color: #333333;
          }
        }
        .deduc-item:last-child{
          padding-bottom: 0;
        }
      }
    }
.complain{
      position: relative;
      line-height:46px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      padding: 0 16px;
      margin-top: 24px;
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    .complain::after{
      content: '';
      position: absolute;
      right: 16px;
      top: 16px;
      width: 12px;
      height: 12px;
      background: url(../../assets/image/t-right.png) no-repeat;
      background-size: 12px 12px;
    }
  }
</style>
